<template>
  <ion-page>
    <main-header></main-header>
    <ion-content padding>
      <loading-spinner v-if="loading"></loading-spinner>
      <div v-else>
        <div
          v-if="!stripeCards.length"
          class="background-color ion-color-warning ion-padding ion-text-center ion-margin-bottom"
        >
          You have no payment methods saved.
        </div>
        <div v-else>
          <ion-list class="ion-margin-bottom">
            <ion-item
              v-for="stripeCard in stripeCards"
              :key="`stripe-card-${stripeCard.id}`"
              detail
              button
              @click="navigateToEdit(stripeCard.id)"
            >
              <ion-label>
                {{ stripeCard.brand | ucfirst }}
              </ion-label>
              <ion-badge
                v-if="stripeCard.id === defaultStripeCardId"
                color="light"
                class="ion-margin-end"
              >
                primary
              </ion-badge>
              {{ stripeCard.last4 }}
            </ion-item>
          </ion-list>
        </div>
        <ion-button
          @click="handleAddNewCard()"
          expand="block"
          data-cy="add-new-card-button"
        >
          Add a Card
        </ion-button>
      </div>
    </ion-content>
    <available-order-footer></available-order-footer>
  </ion-page>
</template>

<script>
import StripeCard from "@/models/StripeCard";
import errorAlert from "@/ErrorAlert";
import { mapGetters } from "vuex";

export default {
  title: "Payment Methods",

  data: function() {
    return {
      loading: true,
      stripeCards: [],
      defaultStripeCardId: null
    };
  },

  created() {
    this.$firestore()
      .collection("users")
      .doc(this.user.uid)
      .collection("stripeCards")
      .withConverter(StripeCard.firebaseConverter)
      .orderBy("isDefault", "desc")
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          let stripeCard = doc.data();
          if (stripeCard.isDefault) {
            this.defaultStripeCardId = stripeCard.id;
          }
          this.stripeCards.push(stripeCard);
        });

        // this is only happening for two reasons: 1) there is a data issue and none are marked
        // or more likely, 2) they just deleted their primary card, and the background trigger
        // hasn't caught up marking the first one as primary
        if (!this.defaultStripeCardId && this.stripeCards.length) {
          this.defaultStripeCardId = this.stripeCards[0].id;
        }
      })
      .catch(e => {
        errorAlert(e.message);
      })
      .finally(() => {
        this.loading = false;
      });
  },

  methods: {
    handleAddNewCard() {
      this.$router.push({ name: "App: Payment Method Add Card" }).catch(e => e);
    },

    navigateToEdit(id) {
      this.$router
        .push({
          name: "App: Payment Method Edit Card",
          params: {
            id
          }
        })
        .catch(e => e);
    }
  },

  computed: {
    ...mapGetters("auth", ["user"])
  }
};
</script>
